module.exports = __webpack_public_path__ + "static/media/Seawatergreenhouseaus_crop3_tablet.a8c32186.jpg";